// extracted by mini-css-extract-plugin
var _1 = "MinimalHeader-module__header___HvuUO";
export { _1 as "header" }
